<template>
  <section class="detail-content">
    <el-button icon="el-icon-back" type="main" @click="handleBack">返回</el-button>
    <div class="detail-title">{{contentInfo.title}}</div>
    <div class="detail-block">
      <el-row class="detail-tag">
        <!--<el-col :span="6" :offset="12">-->
          <!--发布单位：{{contentInfo.organizationName}}-->
        <!--</el-col>-->
        <el-col :span="6" :offset="18">
          发布时间：{{contentInfo.createTime}}
        </el-col>
      </el-row>
      <div class="detail" v-html="contentInfo.content">
      </div>
      <div class="detail-file">
        <div v-for="file in contentInfo.attachments" :key="file.filrUrl">
          <i class="el-icon-link"></i>
          <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import {portalNotifyDetail} from '@/api/restapi.js'
  export default {
    data () {
      return {
        contentInfo: {}
      }
    },
    mounted() {
      if (this.$route.query.id) {
        portalNotifyDetail(this.$route.query.id).then(res => {
          if (res.data.code === 0){
            this.contentInfo = res.data.data
          }
        })
      }
    },
    methods: {
      handleBack () {
        this.$router.back()
      }
    }
  }
</script>
<style>
  @import "../../style/Table.css";
  .detail-content {
    background: #FFFFFF;
    width: 100%;
    padding:10px
  }
  .detail-content .detail-title {
    width: 100%;
    margin-top: 5px;
    text-align: center;
    font-size: 18px;
    color: #0068BC;
  }
  .detail-content .detail-block{
    width: 100%;
    border-top: 1px #CECECE solid;
    margin-top: 30px;
    padding-top: 10px;
  }
  .detail-content .detail-tag {
    font-size: 13px;
    color: #ABABAB;
  }
  .detail-content .detail {
    margin-top: 10px;
    font-size: 14px;
  }
  .detail-content .detail img {
    max-width: 100%;
  }
  .detail-content .detail-file {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/NotifyDetail.vue